import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import NativeSelectDemo from './NativeSelectDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, NativeSelectDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/selects/demos/native-demo/NativeSelectDemo.tsx",
    "fileName": "NativeSelectDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport InputLabel from '@mui/material/InputLabel';\nimport FormControl from '@mui/material/FormControl';\nimport NativeSelect from '@mui/material/NativeSelect';\n\nexport default function NativeSelectDemo() {\n  const id = React.useId();\n  return (\n    <Box sx={{ minWidth: 120 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <FormControl fullWidth>\n        <InputLabel variant=\"standard\" htmlFor={`${id}-select`}>\n          Age\n        </InputLabel>\n        <NativeSelect\n          defaultValue={30}\n          inputProps={{\n            name: 'age',\n            id: `${id}-select`,\n          }}\n        >\n          <option value={10}>Ten</option>\n          <option value={20}>Twenty</option>\n          <option value={30}>Thirty</option>\n        </NativeSelect>\n      </FormControl>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 16,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport InputLabel from '@mui/material/InputLabel';\nimport FormControl from '@mui/material/FormControl';\nimport NativeSelect from '@mui/material/NativeSelect';\n\nexport default function NativeSelectDemo() {\n  const id = React.useId();\n  return (\n    <Box sx={{ minWidth: 120 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <FormControl fullWidth>\n        <InputLabel variant=\"standard\" htmlFor={`${id}-select`}>\n          Age\n        </InputLabel>\n        <NativeSelect\n          defaultValue={30}\n          inputProps={{\n            name: 'age',\n            id: `${id}-select`,\n          }}\n        >\n          <option value={10}>Ten</option>\n          <option value={20}>Twenty</option>\n          <option value={30}>Thirty</option>\n        </NativeSelect>\n      </FormControl>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControl"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fullWidth"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "InputLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "standard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "htmlFor"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ],
                  [
                    "span",
                    "di-te",
                    [
                      [
                        "span",
                        "di-td",
                        "${"
                      ],
                      [
                        "span",
                        "pl-smi",
                        "id"
                      ],
                      [
                        "span",
                        "di-td",
                        "}"
                      ]
                    ]
                  ],
                  "-select",
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            "          Age"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "InputLabel"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "NativeSelect"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "inputProps"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "            ",
              [
                "span",
                "di-op di-jv",
                "name"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "age",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "            ",
              [
                "span",
                "di-op di-jv",
                "id"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ],
                  [
                    "span",
                    "di-te",
                    [
                      [
                        "span",
                        "di-td",
                        "${"
                      ],
                      [
                        "span",
                        "pl-smi",
                        "id"
                      ],
                      [
                        "span",
                        "di-td",
                        "}"
                      ]
                    ]
                  ],
                  "-select",
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "          }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            "        >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "          <",
              [
                "span",
                "pl-ent",
                "option"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Ten</",
              [
                "span",
                "pl-ent",
                "option"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "          <",
              [
                "span",
                "pl-ent",
                "option"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "20"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Twenty</",
              [
                "span",
                "pl-ent",
                "option"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "          <",
              [
                "span",
                "pl-ent",
                "option"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Thirty</",
              [
                "span",
                "pl-ent",
                "option"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "NativeSelect"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControl"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 29,
    "focusedLines": 16,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/InputLabel",
      "@mui/material/FormControl",
      "@mui/material/NativeSelect"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
